
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[city]/electric-auto",
      function () {
        return require("private-next-pages/[city]/electric-auto/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[city]/electric-auto"])
      });
    }
  